module.exports = __webpack_public_path__ + "static/media/homepage.bc663a21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/homepage.svg
// module id = 461
// module chunks = 0